export const iconFontAwesomeUsersPeoplePersonCirclePlus = (
	<i className="fa-solid fa-person-circle-plus"></i>
);
